import type { IconDefinition } from '../../types'

export default {
  details: [32, 33, [], '', 'M16 19.8334C17.8409 19.8334 19.3333 18.341 19.3333 16.5001C19.3333 14.6591 17.8409 13.1667 16 13.1667C14.159 13.1667 12.6667 14.6591 12.6667 16.5001C12.6667 18.341 14.159 19.8334 16 19.8334Z'],
  name: 'uiDotFullAlt',
  oldName: 'cusDotFullAlt'
} as IconDefinition
